/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 28/12/2021
 * @Example
 */



export const types = {
    W05F0013_GET_LIST: 'W05F0013_GET_LIST',
    W05F0013_ADD: 'W05F0013_ADD',
    W05F0013_EDIT: 'W05F0013_EDIT',
    W05F0013_GET_DECIMALS: 'W05F0013_GET_DECIMALS',
}

export function getList(params, cb) {
    return {
        type: types.W05F0013_GET_LIST,
        params,
        cb
    }
}

export function onAdd(params, cb) {
    return {
        type: types.W05F0013_ADD,
        params,
        cb
    }
}

export function onEdit(params, cb) {
    return {
        type: types.W05F0013_EDIT,
        params,
        cb
    }
}

export function getDecimals(params, cb) {
    return {
        type: types.W05F0013_GET_DECIMALS,
        params,
        cb
    }
}
